module.exports = __webpack_public_path__ + "static/media/chevronDown.13f79680.svg";